exports.default = {
  'create_agent': '建立智能助理',
  'edit_agent': '編輯智能體',
  'agent_name': '智能助理名稱',
  'agent_name_placeholder': '請輸入智能助理名稱',
  'agent_function_intro': '請輸入智能助理功能說明',
  'agent_function_intro_placeholder': '請輸入智能助理功能說明',
  'get_started': '開始建立',
  'avatar': '頭像',
  'input_brief': '請輸入智能體簡介和使用引導',
  'edit_avatar': '更換頭像',
  'greetings': '你好！',
  'greetings_promtp': '問候語',
  'greetings_promtp_placeholder': '請輸入智能體簡介和使用引導',
  'ai_model': 'AI模型',
  'select': '請選擇',
  'brief': '簡介',
  'leading_questions': '回答完畢會有引導問題',
  'citing_sources': '引用來源',
  'citing_sources_desc': '開啟後，AI回答時將顯示引用來源文檔',
  'markdown_desc': '開啟後，內容支持Markdown格式展示',
  'data_source': '數據來源',
  'set_model_context': '設置模型上下文',
  'set_model_context_desc': '開啟後，AI在問答時，將有權限訪問指定的項目內容作為參考依據回答',
  'confirm': '確認',
  'confirm_upload': '確認上傳',
  'input_prompt': '請輸入模型提示語，可以用於設定模型身份以及指令要求',
  'return': '返回',
  'opening_greetings': '開場白',
  'auto_generate': '自動生成',
  'crop_image': '裁剪圖片',
  'model_parameters': '模型參數',
  'opening_greetings_placeholder': '在每次對話開始時發送此消息，讓智能體主動說第一段話可以拉近與用戶間的距離',
  'next_question_advise': '下一步問題建議',
  'next_question_advise_desc': '在AI回复後，為用戶提供 3 條輸入建議',
  'preview_and_debug': '預覽與調試',
  'suggestion': '建議',
  'suggestion_desc': '我們建議使用結構化提示來創建智能體的角色和預提示。結構化的提示更易於閱讀，可以提高回答效率，並使回答效果體驗更好。',
  'copy': '複製',
  'prompt_optimize': '提示詞優化',
  'balance': '平衡',
  'originality': '創意',
  'accurate': '精確',
  'custom': '自定義',
  'chat_enhancement': '聊天增強',
  'please_input_name': '請輸入名稱',
  'please_input_brief': '請輸入簡介',
  'please_input_prompt': '請輸入模型提示語，可以用於設定模型身份以及指令要求',
  'retry': '重試',
  'use': '使用',
  'greetings_optimize': '開場白優化',
  'unpublished_prompt': '本次創建未保存，請確認是否離開！',
  'prompt': '提示',
  'need_crop_image': '是否需要剪切圖片？',
  'crop': '剪切',
  'release': '發布',
  'confirm_leave': '確認離開',
  'upload_without_crop': '不剪切直接上傳',
  'upload_image': '上傳圖片',
  'name_required': '請輸入智能助理名稱',
  'avatar_required': '請上傳頭像',
  'intro_required': '請輸入功能說明',
  'save_success': '保存成功',
  'image_type_error': '圖片類型必須是：gif,jpeg,jpg,png,bmp中的一种',
  'form_not_complete': '表單填寫不完整，請檢查後重新提交！',
  'under_development': '正在開發中...',
  'agent_settings': '智能體設置',
  'integration': '連接集成',
  'data_analysis': '數據分析',
  'user_feedback': '用戶反饋',
  'member_settings': '成員設置',
  'agent_creation': '智能體創建',
  'choose_template': '選擇模板',
  'empty_template': '空白模板',
  'empty_template_desc': '從零開始創建你的智能體',
  'choose_model': '選擇模型',
  'basic_info': '基本信息',
  'agent_desc': '智能體描述',
  'agent_desc_placeholder': '請輸入智能體描述',
  'agent_avatar': '智能體頭像',
  'upload_avatar': '上傳頭像',
  'go_chat': '去聊天',
  'continue_modify': '繼續修改',
  'release_success': '發布成功！',
  'setting': '設置',
  'randomness': '隨機性',
  'randomness_tip': '調整AI回答的創造性和多樣性，值越大回答越多樣',
  'configure_agent': '配置智能體',
  'stable': '穩定',
  'neutral': '中立',
  'prompt_tips': 'Prompt提示詞',
  'random': '隨機',
  'view_reference_example': '查看參考示例',
  'optimize': '一鍵優化',
  'prompt_placeholder': '請輸入智能體提示詞，如：你是一個專業的Java開發工程師，擅長Spring Boot開發...',
  'save_failed': '保存失敗，缺少必要的配置信息，請檢查！',
  'new_conversation': '新的對話',
  'debug_mode_not_share': '調試模式不允許分享',
  'agent_prompt': '智能體提示詞',
  'agent_prompt_tip': '這裡可以詳細描述你的智能體，比如需要扮演什么角色，擅長什么，應該如何回答問題等，所有對話都將基於此提示詞進行。',
  'agent_prompt_placeholder': '請輸入智能體提示詞，如：你是一個專業的Java開發工程師，擅長Spring Boot開發...',
  'first_question': '首次提問',
  'first_question_tip': '用戶第一次和你的智能體對話時，智能體會主動詢問此問題',
  'first_question_placeholder': '請輸入首次提問，如：你好，我是AI助手，請問有什么可以幫到你的嗎？',
  'knowledge_base': '知識庫',
  'select_knowledge_base': '選擇知識庫',
  'knowledge_base_tip': '選擇知識庫後，用戶提問時智能體會在知識庫中查找相關信息，並利用這些信息來回答問題',
  'no_knowledge_base': '暫無知識庫',
  'create_knowledge_base': '創建知識庫',
  'access_permission': '訪問權限',
  'team_public': '團隊公開',
  'team_public_desc': '所有團隊成員可以使用',
  'team_private': '團隊私有',
  'team_private_desc': '僅自己和指定成員可以使用',
  'web_public': '網頁公開',
  'web_public_desc': '可生成網頁連結，任何人可以訪問',
  'all_members_tip': '所有成員（{count}）',
  'member_count': '{count}個成員',
  'cancel': '取 消',
  'save': '保 存',
  'create': '創 建',
  'choose_avatar': '選擇頭像',
  'agent_avatar_tip': '為您的智能體選擇一個頭像，這將顯示在對話界面',
  'use_default_avatar': '使用默認頭像',
  'upload_local_image': '上傳本地圖片',
  'upload_tip': '支持.jpg.jpeg.png.gif格式，大小不超過3MB',
  'model_recommend': '推薦',
  'model_desc': '模型描述',
  'completion_model': '生成式模型',
  'completion_model_desc': '適用於文本生成、內容創作、對話生成等場景',
  'embedding_model': '嵌入式模型',
  'embedding_model_desc': '適用於語義搜索、文本相似度計算等場景',
  'model_provider': '模型提供方',
  'model_parameter': '{parameter}參數',
  'model_training': '{training_date}訓練',
  'knowledge_base_selected': '已選擇知識庫：{name}',
  'agent_name_required': '請輸入智能體名稱',
  'agent_prompt_required': '請輸入智能體提示詞',
  'agent_first_question_required': '請輸入首次提問',
  'create_success': '創建成功',
  'leave_confirm': '確認離開當前頁面嗎？您的更改可能未保存。',
  'leave_page': '離開頁面',
  'stay_on_page': '留在頁面',
  'edit_members': '編輯成員',
  'member_list': '成員列表',
  'member_count_tip': '已選擇{count}個成員',
  'search_member': '搜索成員',
  'all_members': '全部成員',
  'selected_members': '已選成員',
  'agent_link': '智能體連結',
  'link_tip': '透過以下連結，您可以在任何地方分享和使用您的智能體，任何人都可以訪問和使用',
  'page_link': '頁面連結',
  'scan_qrcode': '掃描QR Code',
  'embed_code': '嵌入碼',
  'embed_tip': '將此碼嵌入您的網站，即可在網站上使用您的智能體',
  'embed_code_copied': '嵌入碼已複製',
  'link_copied': '連結已複製',
  'close': '關 閉',
  'member_management': '成員管理',
  'member_search_placeholder': '搜索成員姓名',
  'add_member': '添加成員',
  'name': '姓名',
  'permission': '權限',
  'operation': '操作',
  'remove': '移除',
  'add_new_member': '添加新成員',
  'search_by_name': '搜索成員姓名',
  'no_results': '暫無搜索結果',
  'admin': '管理員',
  'editor': '編輯者',
  'viewer': '觀看者',
  'team_owner': '團隊所有者',
  'team_admin': '團隊管理員',
  'agent_owner': '智能體所有者',
  'remove_confirm': '確定要移除該成員嗎？',
  'remove_success': '成員移除成功',
  'add_success': '成員添加成功',
  'permission_update_success': '權限更新成功',
  'agent_setting': '智能體設置',
  'model_setting': '模型設置',
  'reset_setting': '重置設置',
  'setting_reset_confirm': '確定要重置所有設置嗎？',
  'settings_reset_success': '設置已重置',
  'delete_agent': '刪除智能體',
  'delete_agent_confirm': '確定要刪除此智能體嗎？此操作不可撤銷。',
  'delete_success': '刪除成功',
  'agent_deleted': ' 智能體被刪除',
  'agent_disabled': ' 智能體被下架',
  'get_link': '獲取連結',
  'advanced_settings': '進階設置',
  'context_window': '上下文窗口',
  'context_window_tip': '設置智能體能夠"記住"的消息數量。較大的值會讓智能體記住更多歷史消息，但會增加API調用成本。',
  'message_count': '{count}條消息',
  'temperature': '隨機性',
  'temperature_tip': '控制輸出的隨機性。較低的值使輸出更確定，較高的值使輸出更多樣化和創造性。',
  'top_p': '核采樣',
  'top_p_tip': '控制模型在生成每個標記時考慮的詞彙概率質量。較低的值使輸出更確定，較高的值使輸出更多樣化。',
  'max_tokens': '單次回覆限制',
  'max_tokens_tip': '控制模型在每次回覆中最多生成的標記數量。較大的值允許模型生成更長的回覆。',
  'tokens_count': '{count}個標記',
  'presence_penalty': '話題新鮮度',
  'presence_penalty_tip': '控制模型重複已出現的標記的傾向。較高的正值會懲罰模型重複已出現的標記。',
  'frequency_penalty': '頻率懲罰度',
  'frequency_penalty_tip': '控制模型重複已頻繁出現的標記的傾向。較高的正值會懲罰模型重複頻繁出現的標記。',
  'points_per_request': '{points} 積分/次'
}
